export class BrailleNotFoundException extends Error {}
